// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-editor-container[data-v-106c86ed] {\n  padding: 32px;\n  background-color: #f0f2f5;\n  position: relative;\n}\n.dashboard-editor-container .github-corner[data-v-106c86ed] {\n  position: absolute;\n  top: 0px;\n  border: 0;\n  right: 0;\n}\n.dashboard-editor-container .chart-wrapper[data-v-106c86ed] {\n  margin-bottom: 20px;\n}\n@media (max-width: 1024px) {\n.chart-wrapper[data-v-106c86ed] {\n    padding: 8px;\n}\n}", ""]);
// Exports
module.exports = exports;
